import React from 'react'
import type { FC, ReactNode } from 'react'
import { makeStyles, createStyles } from '@material-ui/core/styles'
import clsx from 'clsx'
import type { ITheme } from '@homeviews/styles'

const useStyles = makeStyles((theme: ITheme) =>
  createStyles({
    root: {
      width: '100%',
      '& .MuiAccordionSummary-root.Mui-expanded': {
        minHeight: 30,
      },
      '& .MuiAccordionSummary-content.Mui-expanded': {
        margin: 0,
      },
      '& .c-accordionDetails': {
        width: '100%',
      },
      '& .c-accordionDetail': {
        marginBottom: 8,
        width: '100%',
      },
      '& .c-accordionDetailLabel': {
        fontWeight: 500,
        fontSize: 12,
        lineHeight: '22px',
        letterSpacing: 0.2,
        margin: 0,
        color: theme.colors.grey450,
      },
      '& .c-accordionDetailValue': {
        color: theme.colors.grey800,
        margin: 0,
      },
      '& .c-accordionActions': {
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: 15,
        '& button': {
          flex: 0,
        },
      },
    },
  }),
)

interface IProps {
  className?: string
  children: ReactNode
}

const AccordionWrapper: FC<IProps> = ({ className, children }) => {
  const classes = useStyles()

  return <div className={clsx(classes.root, className)}>{children}</div>
}

export default AccordionWrapper
